import type { ReactNode } from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "@nexus/ui";
import { ASK_NEXUS_ICON_STROKE } from "@/features/ask-nexus/lib/ui";

/** The prototype's alert: a tinted card with an icon, a title, an optional line and an optional action. */
export function AskNexusAlert({
  tone,
  title,
  description,
  action,
  className,
}: {
  tone: "bad" | "neutral";
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}) {
  return (
    <div
      role="alert"
      className={cn(
        "flex items-start gap-3 rounded-2xl px-4 py-3.5",
        tone === "bad" ? "bg-(--an-neg-tint)" : "bg-(--an-inset)",
        className,
      )}
    >
      <AlertCircle
        className={cn("mt-px size-4 flex-none", tone === "bad" ? "text-(--an-neg-ink)" : "text-(--an-ink-2)")}
        strokeWidth={ASK_NEXUS_ICON_STROKE}
        aria-hidden="true"
      />
      <div className="min-w-0">
        <p className={cn("text-[13px] font-medium", tone === "bad" && "text-(--an-neg-ink)")}>{title}</p>
        {description ? <p className="mt-0.5 text-[13px] leading-normal text-(--an-ink-2)">{description}</p> : null}
        {action ? <div className="mt-2.5 flex flex-wrap items-center gap-2">{action}</div> : null}
      </div>
    </div>
  );
}
